/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../../config/userLists.config.json';
import { useOrgId } from '../provider';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { GET_SUBMITTED_APPLICATION } from '@pages/SubmittedApplications/api/graphql';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    console.log(`getUserListsProps service token : :`);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_SUBMITTED_APPLICATION, {
          skip: 0,
          limit: 10,
          criteria: {
            status: 'submitted',
            userEmail: userData?.email,
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(res?.data?.getApplication?.data);
          console.log(`row data`, _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            userRoles: res?.data?.getRoleList?.data,
            isEmpty: res?.data?.getApplication?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getApplication?.currentPage,
            pageSize: res?.data?.getApplication?.pageSize,
            totalCount: res?.data?.getApplication?.totalCount,
            totalPages: res?.data?.getApplication?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?._id,
          // status: item?.status,
          firstName: item?.employeeInfo?.firstName
            ? toHeaderCase(item?.employeeInfo?.firstName ?? '')
            : '',
          middleName: item?.employeeInfo?.middleName
            ? toHeaderCase(item?.employeeInfo?.middleName ?? '')
            : '',
          lastName: item?.employeeInfo?.lastName
            ? toHeaderCase(item?.employeeInfo?.lastName ?? '')
            : '',
          appliedOn: this.formatCreatedDate(item?.createdAt),
          status: item?.status,
          applicationId: index + 1,
          nationality: item?.employeeInfo?.nationality ?? '-',
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return 'suspended';
    } else {
      switch (status) {
        case 'USER_ADDED':
          return 'created';
        case 'USER_INVITED':
          return 'invited';
        case 'USER_EMAIL_VERIFIED':
          return 'verified';
        case 'USER_VERIFIED':
          return 'verified';
        case 'USER_ACC_CREATED':
          return 'active';
        case 'WALLET_REGISTERED':
          return 'active';
        case 'SUSPENDED':
          return 'suspended';
        default:
          return '-';
      }
    }
  }
}
